import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Credly|Templates|Expire Date Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
};

export type SPToolCredlyTemplatesExpireDateModalLocNames =
	| 'SPToolCredlyTemplatesExpireDateModalTitle'
	| 'SPToolCredlyTemplatesExpireDateModalLabelExpireDate'
	| 'SPToolCredlyTemplatesExpireDateModalBadgesWarning'
	| 'SPToolCredlyTemplatesExpireDateModalErrorExpireDateRequired'
	| 'SPToolCredlyTemplatesExpireDateModalErrorExpireDateInvalid'
	| 'SPToolCredlyTemplatesExpireDateModalErrorTemplateDataMissing'
	| 'SPToolCredlyTemplatesExpireDateModalErrorUpdateFailed'
	| 'SPToolCredlyTemplatesExpireDateModalButtonCancel'
	| 'SPToolCredlyTemplatesExpireDateModalButtonSave';

export const spToolCredlyTemplatesExpireDateModalLocs: LocDefs<SPToolCredlyTemplatesExpireDateModalLocNames> =
	{
		SPToolCredlyTemplatesExpireDateModalTitle: {
			defaultValue: 'Expire Date',
			description: 'Modal title for editing expiration date',
			displayPath: `${pathStart}Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: 'Label for expiration date field',
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalBadgesWarning: {
			defaultValue:
				'Badges associated with this template will NOT be processed after the expire date',
			description:
				'Warning text explaining that badges will not be processed after template expiration',
			displayPath: `${pathStart}Badges Warning`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalErrorExpireDateRequired: {
			defaultValue: 'Expiration date is required',
			description: 'Error message when expiration date is required',
			displayPath: `${pathStart}Error Required`,
			displayType: 'Error',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalErrorExpireDateInvalid: {
			defaultValue: 'Expiration date must be in the future',
			description: 'Error message when expiration date is not in the future',
			displayPath: `${pathStart}Error Invalid`,
			displayType: 'Error',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalErrorTemplateDataMissing: {
			defaultValue: 'Template data is incomplete. Cannot update expiration date.',
			description: 'Error message when template catalogId or type is missing',
			displayPath: `${pathStart}Error Template Data Missing`,
			displayType: 'Error',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalErrorUpdateFailed: {
			defaultValue: 'Failed to update expiration date. Please try again.',
			description: 'Error message when the expiration date update fails',
			displayPath: `${pathStart}Error Update Failed`,
			displayType: 'Error',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button text',
			displayPath: `${pathStart}Button Cancel`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPToolCredlyTemplatesExpireDateModalButtonSave: {
			defaultValue: 'Save',
			description: 'Save button text',
			displayPath: `${pathStart}Button Save`,
			displayType: 'Button',
			...sharedProperties,
		},
	};

export type SPToolCredlyTemplatesExpireDateModalLocType =
	LocMap<SPToolCredlyTemplatesExpireDateModalLocNames>;
